enum DownloadEnum {
    downloadCenterDesc = "cn.downloadCenterDesc",
}
export default DownloadEnum;
